import { Product, ProductManufacturer } from "../Product/Product";
import { DmsManufacturer } from "../ShoppingPortal/DmsManufacturer";

export interface DealerLocation {
  id?: string;
  dealerId: number;
  dmsType: number;
  dmsLocationId: number;
  name: string;
  address: string;
  city: string;
  stateOrProvince: string;
  zipPostal: string;
  email: string;
  phone?: string;
  shopifyLocationId: number;
  isDefault: boolean;
}

export interface LocationPart {
  dealerId: string;
  inventoryPartId: string;
  manufacturerId: string;
  partNumber: string;
  description: string;
  price: number;
  availableQty: number;
  partNodash?: string;
  stockItem: boolean;
  locationCount: LocationPartCount[];
  averageCost: number;
  suggestedRetailPrice: number;
  mfrName?: string;
  mfrCode?: string;
  moreInfo: string;
}

export interface LocationWholegood {
  inventoryModelId: string;
  manufacturerId: string;
  model: string;
  modelId: number;
  price: number;
  cost: number;
  suggestedRetailPrice: number;
  moreInfo: string;
  description: string;
  productLine: string;
  subProduct: string;
  stockItem: boolean;
  locationCount: LocationWholegoodCount[];
  mfrCode?: string;
  mfgName?: string;
}

export interface LocationWholegoodCount {
  locationId: number;
  count: number;
  locationTitle?: string;
}

export interface LocationPartCount {
  locationId: number;
  count: number;
  locationTitle?: string;
}

export interface DmsSetupState {
  wholegoods: {
    items: LocationWholegood[];
    matchedItems: LocationWholegood[];
    misMatchedItems: LocationWholegood[];
  };
  parts: LocationPart[];
  itemTypes: string[];
  matchedProducts: MatchedProduct[];
  missMatchedProducts: LocationWholegood[];
  missMatchedParts: LocationPart[];
  matchedWholegoods: MatchedProduct[];
  matchedParts: MatchedProduct[];
  locationIds: string[];
  typeToProcess: string[];
  stocking: boolean;
  withQtyOnly: boolean;
  storeAccessToken?: string;
  storeUrl?: string;
  siteName?: string;
  isSyncing?: boolean;
  dmsWholeGoods: LocationWholegood[];
  dmsParts?: LocationPart[];
  dealerManufacturers: ProductManufacturer[];
  mappedLocations: DealerLocation[];
  dmsManufacturers: DmsManufacturer[];
  IsSyncCompleted?: boolean;
  setupType: SetupType;
  siteCredentials: string;
}

export interface MatchedProduct {
  dmsProduct?: LocationWholegood;
  dmsPart?: LocationPart;
  catalogProduct?: Product;
  isManuallyMatched?: boolean;
}

export interface NotSyncedResponse {
  wholegoods: LocationWholegood[];
  parts: LocationPart[];
}

export interface MatchedProductRes {
  dmsProduct?: LocationWholegood;
  catalogPorduct?: Product;
}
export interface AggregateSyncStatusRequest {
  aggregateId: string;
  isEnable: boolean;
  requestFor: RequestFor;
  setupType: SetupType;
}
export interface GetWGSerialRequest {
  dealerIds: string[];
  model: string;
  mfrCode: string;
  everestDmsDealerId: string;
}
export enum ProductType {
  Wholegoods = 0,
  Parts = 1,
  NewArrival = 2,
  UsedProduct = 3,
  EmbeddedPart = 4,
}
export enum PricingType {
  Price,
  MSRP,
  PriceLevel1,
  PriceLevel2,
  PriceLevel3,
  PriceLevel4,
  PriceLevel5,
}
export enum RequestFor {
  Price,
  Stock,
  Catalog,
}

export enum PurchaseUnit {
  EA = "EA",
  FT = "FT",
  PKG = "PKG",
  CD = "CD",
  BAG = "BAG",
  RL = "RL",
  CS = "CS",
  GAL = "GAL",
  CTN = "CTN",
  PL = "PL",
  BX = "BX",
  DSP = "DSP",
  ROW = "ROW",
  PR = "PR",
  PGK = "PGK",
  SET = "SET",
  LB = "LB",
  C = "C",
  M = "M",
  WKT = "WKT",
  DZ = "DZ",
  Pcs = "Pcs",
  PCE = "PCE",
}

export enum DmsSetupDefaultType {
  ShippingItem,
}
export enum SetupType {
  ShopifyLegacy = "ShopifyLegacy",
  Shopify = "Shopify",
  HiImpact = "HiImpact",
  BigCommerce = "BigCommerce",
}
